import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const TrainSolid = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="m7.613.268c-1.099.123-3.606.551-4.553.776l-.34.08v2.129h10.56v-2.122l-.78-.152a94.064 94.064 0 0 0 -2.66-.485c-1.355-.226-1.813-.273-2.227-.226m-4.893 5.172v1.014l2.34-.007 2.34-.007v-2l-2.34-.007-2.34-.007zm5.879-.98c-.007.019-.01.472-.006 1.007l.007.973 2.34.007 2.34.007v-2.027h-2.334c-1.847 0-2.337.007-2.347.033m-5.885 5.16a221.088 221.088 0 0 0 0 2.136c.013.277.183.53.424.631.054.022.172.05.262.06l.164.02-1.466 1.746-1.465 1.747 3.683.007c2.026.003 5.342.003 7.368 0l3.683-.007-1.465-1.747-1.466-1.746.164-.02c.09-.01.208-.038.262-.06a.724.724 0 0 0 .424-.631c.003-.078.003-1.04 0-2.136l-.006-1.993h-10.56zm3.406-.899a.838.838 0 0 1 .309.21c.196.196.275.39.274.669a.867.867 0 0 1 -.274.669.86.86 0 0 1 -.669.275.86.86 0 0 1 -.669-.275.909.909 0 0 1 -.241-.931c.168-.554.723-.824 1.27-.617m4.48 0a.838.838 0 0 1 .309.21.86.86 0 0 1 .275.669.86.86 0 0 1 -.275.669.86.86 0 0 1 -.669.275.86.86 0 0 1 -.669-.275.909.909 0 0 1 -.241-.931c.168-.554.723-.824 1.27-.617m.413 3.912c.081.097.151.187.156.199s-1.421.021-3.169.021-3.174-.009-3.169-.021.075-.102.156-.199l.146-.176h5.734zm1.468 1.754c.153.184.283.346.288.359.005.016-1.788.025-4.769.025s-4.774-.009-4.769-.025c.005-.013.135-.175.288-.359l.28-.334h8.402z" fillRule="evenodd" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { TrainSolid };